import * as React from "react";
import DatePicker from "material-ui/DatePicker";

import * as moment from "moment-timezone";

import TopMerchantsContainer from "app/components/AppComponents/Fraud/TopMerchantsContainer";

type State = {
  filterDate: Date;
};

export default class TopMerchants extends React.Component<any, State> {
  constructor(props: any) {
    super(props);

    const filterDate = new Date();
    filterDate.setDate(filterDate.getDate() - 1);

    this.state = {
      filterDate
    };
  }

  fromAndToForDate = (date: Date) => {
    const from = moment(date)
      .startOf("day")
      .tz("Africa/Johannesburg")
      .format();
    const to = moment(date)
      .endOf("day")
      .tz("Africa/Johannesburg")
      .format();

    return { from, to };
  };

  componentDidMount() {
    this.props.setHeader({
      title: "Fraud > Top Merchants",
      description: "Top SnapScan merchants"
    });
  }

  render() {
    const { from, to } = this.fromAndToForDate(this.state.filterDate);

    return (
      <section className="padded">
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start"
          }}
        >
          <DatePicker
            hintText="Data of"
            onChange={(e, date) => {
              this.setState({ filterDate: date });
            }}
            defaultDate={this.state.filterDate}
            style={{
              width: "200px",
              marginRight: "10px"
            }}
            textFieldStyle={{
              width: "200px"
            }}
          />
        </div>

        <TopMerchantsContainer
          name={"fraud.topmerchants"}
          from={from}
          to={to}
        />
      </section>
    );
  }
}
